<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="4">
          <b-card-group>
            <b-card no-body class="p-4">
              <b-card-body>
                
                <BlockUI message="loading" v-if="isLoading">
                  <i class="fa fa-cog fa-spin fa-3x fa-fw"></i>
                </BlockUI>
                <b-form  v-on:submit.prevent="saveForm()">
                  
                  <div style="text-align:center">
                    <!--
                    <img src="http://aresplanner.com/assets/img/logo.png" style="width:150px;" />
                    -->
                    <p class="text-muted">Please enter your email address</p>
                  </div>
                  
                  <b-alert :variant="msg_type"
                          dismissible
                          :show="msg!=''"
                          @dismissed="msg=''">
                    {{msg}}
                  </b-alert>
                  <b-input-group class="mb-3">
                    <b-input-group-prepend><b-input-group-text><i class="icon-user"></i></b-input-group-text></b-input-group-prepend>
                    <b-form-input type="email" class="form-control" placeholder="Email" autocomplete="username email" v-model="user.email" required />
                  </b-input-group>
                  <b-row>
                    <b-col cols="6">
                      <b-button variant="primary" class="px-4" type="submit" :disabled="isLoading" >Submit</b-button>
                    </b-col>
                    <b-col cols="6" class="text-right">
                      <b-button variant="link" class="px-0" type="button" @click="goToLogin" :disabled="isLoading" >Back to login?</b-button>
                    </b-col>
                  </b-row>
                </b-form>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Login',
  data: () => {
    return {
      error: false,
      user: {
        email: '',
        password: '',
      },
      msg : '',
      msg_type : '',
      isLoading:false,
    }
    
  },
  methods: {
    goToLogin(){
      this.$router.replace(`/auth/login`);
    },
    goToForgotPassword(){
      this.$router.replace(`/auth/forgot_password`);
    },
    
    saveForm() {
      var app = this;
      var newDt = app.user;
      var url = this.end_point+'forgot_password';

      app.isLoading=true;
      axios.post(url, newDt)
      .then(function (resp) {
        app.isLoading=false;
        if(resp.data.error){
          app.msg = resp.data.msg;
          app.error = resp.data.error;
          app.msg_type = 'danger';
          window.scrollTo(0,0);
        }else{
          app.error = false;
          app.msg_type = 'info';
          app.msg = resp.data.msg;
          //app.$router.replace(`/auth/login`);
        }
      })
      .catch(function (resp) {
        app.isLoading=false;
        app.msg = 'could not save';
        app.msg_type = 'danger';
        app.error = true;
      });
    },

  }
}
</script>
